export const ROUTE_STATE_KEY = 'routes';
export const LANGUAGE_KEY = 'language';
export const REMEMBERED_MAIL_KEY = 'rememberedMail';
export const CONTEXT_DATA_KEY = 'contextData';
